
// Use the native method `filter` to loop through the array and leave only those entries that pass the given callback function onlyUnique.
// onlyUnique checks, if the given value is the first occurring. If not, it must be a duplicate and will not be copied.
// https://stackoverflow.com/a/14438954/19588
export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

// https://stackoverflow.com/a/37320681
// Helper function to find values that are common to all passed in arguments.
export function intersection() {
    let result = [];
    let lists;

    if(arguments.length === 1) {
        lists = arguments[0];
    } else {
        lists = arguments;
    }

    for(let i = 0; i < lists.length; i++) {
        let currentList = lists[i];
        for(let y = 0; y < currentList.length; y++) {
            let currentValue = currentList[y];
            if(result.indexOf(currentValue) === -1) {
                let existsInAll = true;
                for(let x = 0; x < lists.length; x++) {
                    if(lists[x].indexOf(currentValue) === -1) {
                        existsInAll = false;
                        break;
                    }
                }
                if(existsInAll) {
                    result.push(currentValue);
                }
            }
        }
    }
    return result;
}

export function isArray(obj) {
    if (typeof Array.isArray !== 'undefined') return Array.isArray(obj);
    return Object.prototype.toString.call(obj) === '[object Array]';
}

// @link https://stackoverflow.com/a/23976260/19588
export function randItem(items) {
    // "~~" for a closest "int"
    return items[~~(items.length * Math.random())];
}

/**
 * Get the array item which has the highest occurrence.
 * @link https://stackoverflow.com/a/20762713/19588
 * @param arr {Array}
 * @returns {any}
 */
export function mode(arr){
    return arr.sort((a,b) =>
        arr.filter(v => v===a).length
        - arr.filter(v => v===b).length
    ).pop();
}